import { Component, Inject, OnInit } from '@angular/core';
import { AnModalService, MODAL_DATA } from '@autonation/dt-an-components-lib/an-modal';

@Component({
  selector: 'lib-base-tooltip-modal',
  templateUrl: './base-tooltip-modal.component.html',
  styleUrls: ['./base-tooltip-modal.component.scss'],
  standalone: false
})
export class BaseTooltipModalComponent implements OnInit {

  constructor(
    @Inject(MODAL_DATA) public data: any,
    private modalService: AnModalService
  ) { }

  ngOnInit(): void {
  }

  closeModal() {
    this.modalService.close();
    document.documentElement.style.overflow = 'auto';
  }

}
